const embedContainers = document.querySelectorAll('.pp-youtube-embed')

embedContainers.forEach( container => {
    const cover = container.querySelector('.pp-youtube-embed__cover')
    const button = container.querySelector('.pp-youtube-embed__consent')
    const iframe = container.querySelector('iframe')
    let iframeData = iframe.getAttribute('data-src')

    const iframeDataTestArr = [
        {
            prefix: 'youtube.com/watch?v=',
            test: /(youtube.com\/watch\?v=)/.test( iframeData ),
        }, {
            prefix: 'youtu.be/',
            test: /(youtu.be\/)/.test( iframeData ),
        }, {
            prefix: 'youtube.com/embed/',
            test: /(youtube.com\/embed)/.test( iframeData ),
        }
    ]
    const iframeDataPrefix = iframeDataTestArr.filter( data => data.test ).map( data => data.prefix )

    if ( iframeDataPrefix.length > 0 ) {
        iframeData = iframeData.split(iframeDataPrefix)
        iframeData = iframeData[iframeData.length - 1]
    }

    if (button) button.onclick = e => {
        container.style.height = `${cover.offsetHeight}px`

        setTimeout( () => {
            container.classList.add('pp-youtube-embed__consent-given')
            container.style.height = '0px'

            setTimeout( () => {
                container.classList.add('pp-youtube-embed__conver-hide')
                iframe.setAttribute('src', `https://www.youtube.com/embed/${iframeData}?autoplay=1`)
            }, 100);
        }, 200);
    }

    // if (cookie 30min for all youtube videos on site?) button.click() (?) // IDEA
})

